import _ from 'lodash';
import { createSelector } from 'reselect';
import pathOr from 'ramda/src/pathOr';
import { BusinessUnitCustomPagesTemplateSelector, BusinessUnitHasTemplateSelector } from 'invision-core/src/components/configurable/configurable.selectors';
export var RouteParams = function RouteParams(state) {
  return pathOr(null, ['router', 'currentParams'], state);
};
export var CurrentPageIdSelector = createSelector([RouteParams], function (routeParams) {
  return pathOr(null, ['pageId'], routeParams);
});
export var PageDataSelector = createSelector([BusinessUnitHasTemplateSelector, BusinessUnitCustomPagesTemplateSelector, CurrentPageIdSelector], function (hasTemplate, customPages, pageId) {
  if (hasTemplate) {
    var currentPageData = _.find(customPages, function (page) {
      return page.Id === pageId;
    });
    return currentPageData ? currentPageData : null;
  }
  return null;
});